//Whatsnew have to be present in production alone
import React, {
  useState,
  useEffect,
  memo,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from "react";
import { NavLink, Link } from "react-router-dom";
import { Navbar, Dropdown, Modal, Button, Image } from "react-bootstrap";
import { Avatar } from "antd";
import logo from "../../assets/images/vozo-logo-1.png";
import "./TopNavbar.css";
import Icon from "@ant-design/icons/lib/components/Icon";
import CalendarTodayOutlined from "@material-ui/icons/CalendarTodayOutlined";
import NewAppointment from "../popups/NewAppointment";
import CreateClient from "../popups/CreateClient";
import IntakeForms from "../patient/IntakeForms";
import { useHistory, useLocation } from "react-router-dom";
import axiosInstance from "../../axios/axios";
import AcUnitOutlinedIcon from "@material-ui/icons/AcUnitOutlined";
import { changeFacilitySelect } from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import { BiLockAlt } from "react-icons/bi";
// import { MdArrowUpward } from "react-icons/md";
import { MdManageAccounts } from "react-icons/md";
import Add from "@material-ui/icons/Add";
import { BsCheckCircle } from "react-icons/bs";
import { BiHelpCircle } from "react-icons/bi";
import { BsHeadset } from "react-icons/bs";
import styled from "styled-components";
import Notifications from "./Notifications";
import PasswordExpired from "../popups/PasswordExpired";
import { AutoComplete } from "antd";
import { AiOutlineSearch } from "react-icons/ai";
import rect from "../../assets/images/Rectangle_761.webp";
import { Button1 } from "../setting/PatientPortalSettings/StyledComponents";
import { MdOutlineSignalWifiConnectedNoInternet4 } from "react-icons/md";
import Messenger from "../Messages/index";
import {
  changeShowcontact,
  GetMsgList,
} from "../../StateManagement/Reducers/PatientState";
import whats_new_loudspeaker from "../../../src/assets/images/whats_new_loudspeaker.png";

import {
  getSecureMessageList,
  gettotalUnreadCount,
} from "../../StateManagement/Reducers/MessageState";
import { useSelector } from "react-redux";
import UpgradeRequired from "../popups/UpgradeRequired";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import moment from "moment";
import NewSource from "./NewSource";
import {
  fileTypes,
  fileurl,
  generateFileURL,
  WhatsNewUrl,
  AccessMailUrl,
} from "../../axios/url.js";
import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../MiddleWare/EncryptDecrypt/index.js";
import logout from "../../logout.js";
import axios from "axios";
import GetStartedPopup from "../popups/GetStartedPopup.js";
import { Popup } from "semantic-ui-react";
import { IoCloseSharp } from "react-icons/io5";
import { parsePhoneForDisplay } from "../patient/ParsePhoneForDisplay.js";
const Prompt = styled.div`
  background: #f55151;
  color: #ffffff;
  border-radius: 50%;
  width: 9px;
  height: 9px;
  min-width: 9px;
  min-height: 9px;
  padding: 0;
  font-size: 0;
  display: block;
  position: absolute;
  right: -3px;
  top: -3px;
  line-height: 0;
  z-index: 10;
  // display: ${(props) => (props.display === "0" ? "none" : "block")};
`;
// Square box + tail message SVG
const SquareMessageSvg = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none">
    <path
      d="M4 4h16v12H8l-4 4V4z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="miter"
      strokeLinecap="square"
    />
    <line x1="8" y1="9" x2="16" y2="9" stroke="currentColor" strokeWidth="2" />
    <line
      x1="8"
      y1="13"
      x2="14"
      y2="13"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
// Account Setting Icon (User + Gear) – exact style
// const AccountSettingSvg = () => (
//   <svg
//     viewBox="0 0 24 24"
//     width="1em"
//     height="1em"
//     fill="currentColor"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     {/* User Head */}
//     <circle cx="9" cy="7" r="3" />

//     {/* User Body */}
//     <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" />

//     {/* Gear */}
//     <path
//       d="
//       M18.2 12.4
//       l.6 1.2
//       1.4.2
//       -.2 1.4
//       1 1
//       -1 1
//       .2 1.4
//       -1.4.2
//       -.6 1.2
//       -1.2-.6
//       -1.2.6
//       -.6-1.2
//       -1.4-.2
//       .2-1.4
//       -1-1
//       1-1
//       -.2-1.4
//       1.4-.2
//       .6-1.2
//       1.2.6
//       1.2-.6
//       z
//       M16.5 15
//       a1.5 1.5 0 1 0 3 0
//       a1.5 1.5 0 1 0 -3 0
//     "
//     />
//   </svg>
// );

// const AccountSettingIcon = (props) => (
//   <Icon component={AccountSettingSvg} {...props} />
// );

// Ant Design compatible icon wrapper
const SquareMessageIcon = (props) => (
  <Icon component={SquareMessageSvg} {...props} />
);
// Small centered plus SVG
const SmallPlusSvg = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none">
    {/* Vertical line */}
    <line
      x1="12"
      y1="5"
      x2="12"
      y2="19"
      stroke="currentColor"
      strokeWidth="2.8"
      strokeLinecap="square"
    />
    {/* Horizontal line */}
    <line
      x1="5"
      y1="12"
      x2="19"
      y2="12"
      stroke="currentColor"
      strokeWidth="2.8"
      strokeLinecap="square"
    />
  </svg>
);
// Custom Bell SVG
const CustomBellSvg = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Scale group to remove internal padding */}
    <g transform="translate(12 12) scale(1.15) translate(-12 -12)">
      {/* Bell body */}
      <path
        d="M12 3
         C9.5 3 7.5 5 7.5 8
         V12
         C7.5 13.5 6.8 14.8 5.8 15.8
         L5 16.5
         H19
         L18.2 15.8
         C17.2 14.8 16.5 13.5 16.5 12
         V8
         C16.5 5 14.5 3 12 3Z"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Left wave */}
      <path
        d="M4 9 C3 10.5 3 13.5 4 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Right wave */}
      <path
        d="M20 9 C21 10.5 21 13.5 20 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Bottom dot */}
      <circle cx="12" cy="19" r="1.6" fill="currentColor" />
    </g>
  </svg>
);

const UpgradeArrowSvg = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none">
    {/* Arrow body (thick rectangle style) */}
    <rect x="10" y="7" width="4" height="12" fill="currentColor" />

    {/* Arrow head (big triangle) */}
    <polygon points="4,11 12,3 20,11" fill="currentColor" />
  </svg>
);

const UpgradeArrowIcon = (props) => (
  <Icon component={UpgradeArrowSvg} {...props} />
);

const CustomBellIcon = (props) => <Icon component={CustomBellSvg} {...props} />;

// Ant Design wrapper
const SmallPlusIcon = (props) => <Icon component={SmallPlusSvg} {...props} />;

if (localStorage.getItem("token") === "undefined undefined") {
  localStorage.clear();
  localStorage.setItem("logout", true);
}
const TopNavbar = forwardRef((props, ref) => {
  let history = useHistory();

  const location = useLocation();

  // ------------------------------ State and Variables Start--------------------------------------------------- //

  let accountType = Decrypt_Value(localStorage.getItem("account_type"), "vozo");
  const fromComponent = useSelector((state) => state.getStarted.fromComponent);
  const trigger = useSelector((state) => state.getStarted.fromComponentTrigger);
  const dispatch = useDispatch();
  const [selectedPatientTitle, setSelectedPatientTitle] = useState("");
  const [countryCodes, setCountryCodes] = useState([]);
  const [reload, setreload] = useState(true);
  const [search, setSearch] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [username, setusername] = useState("");
  const [useremail, setuseremail] = useState("");
  const [fornoresults, setnoresult] = useState("");
  const [patimg, setpatimg] = useState("");
  const [refresh, setRefresh] = useState(true);

  const [showIntakeForms, setShowIntakeForms] = useState(false);
  const [intakeData, setIntakeData] = useState({
    id: null,
    name: "",
    email: "",
  });
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [showApp, setShowApp] = useState(false);
  const [modalAlerShow, setModalAlerShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [seenTask, setSeenTask] = useState(0);
  const [AppointmentNotification, setAppointmentNotification] = useState([]);
  const [AppointmentSecureMessage, setAppointmentSecureMessage] = useState([]);
  const [NotifyAlert, setNotifyAlert] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [redirectTo1, setRedirectTo1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [id, setid] = useState("0");
  const [countnotify, setCountnotify] = useState("0");
  const [NotifyAlert1, setNotifyAlert1] = useState(false);
  const count = useSelector((state) => state.Message.totalcount);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const refreshTopNav = useSelector(
    (state) => state.ScheduleWidget.refreshTopNav,
  );
  const [showOnlineAlert, setShowOnlineAlert] = useState(false);
  const [newPostAlert, setNewPostAlert] = useState(false);
  const [showStepFiveIntro, setShowStepFiveIntro] = useState(false);
  const [showStepSixIntro, setShowStepSixIntro] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [alertData, setAlertData] = useState(null);
  const apptFromDate = moment(new Date()).format("YYYY-MM-DD");
  const apptToDate = moment(new Date()).format("YYYY-MM-DD");
  const dtFormat = "MM-DD-YYYY";
  const [facId, setFacId] = useState(
    localStorage.getItem("facility_id") &&
      Decrypt_Value(localStorage.getItem("facility_id"), "vozo"),
  );

  const user_id =
    localStorage.getItem("user_id") &&
    Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const authorized =
    localStorage.getItem("authorized") &&
    Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const main_pro =
    localStorage.getItem("main_pro") &&
    Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const owner_id =
    localStorage.getItem("owner_id") &&
    Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  const storedNames =
    localStorage.getItem("setroles") &&
    Decrypt_Value(localStorage.getItem("setroles"), "vozo");

  const uid =
    localStorage.getItem("user_id") &&
    Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const ufc =
    localStorage.getItem("facility_id") &&
    Decrypt_Value(localStorage.getItem("facility_id"), "vozo");
  const provarray = localStorage.getItem("user_id") && [
    Decrypt_Value(localStorage.getItem("user_id"), "vozo"),
  ];
  const facarray = localStorage.getItem("facility_id") && [
    Decrypt_Value(localStorage.getItem("facility_id"), "vozo"),
  ];
  const [main_facility, setmain_facility] = useState(
    Decrypt_Value(localStorage.getItem("main_facility"), "vozo"),
  );

  const expired_days =
    localStorage.getItem("expired_days") &&
    Decrypt_Value(localStorage.getItem("expired_days"), "vozo");

  const [MsgCount, setMsgCount] = useState(0);
  // const [clientAddIs, setClientAddIs] = useState(false);
  const [clientAddPopup, setClientAddPopup] = useState({
    show: false,
    message: "",
  });
  const [officeId, setOfficeId] = useState(
    authorized === "1" ? facId : String(main_facility),
  );
  const NewMsgs = useSelector((state) => state.Message.NewMsgs);
  const [proChat, setProChat] = useState(0);
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [newOpen, setNewOpen] = useState(false);
  const showAdd1 = useSelector((state) => state.Revision?.showAdd1);
  const showAdd2 = useSelector((state) => state.Revision?.showAdd2);
  const Showcontact = useSelector((state) => state.Revision?.Showcontact);
  const [startDate, setStartDate] = useState("");
  const { pathname } = location;
  const [clientFail1, setClientFail1] = useState(false);

  let splitLocation = pathname.split("/");
  // ------------------------------ State and Variables Start--------------------------------------------------- //

  // ------------------------------ Functions Start------------------------------------------------------------- //

  const getStartApptDate = (date) => {
    setStartDate(date);
  };
  const handleIntroNext = () => {
    setShowStepFiveIntro(false);

    history.replace({
      pathname: "/schedule/nav/1",
      search: "?step=6.6",
    });
  };

  const handleIntroBack = () => {
    setShowStepFiveIntro(false);
    history.replace({
      pathname: "/schedule/nav/1",
      search: "?step=6.4",
    });
  };

  const mouseClick = () => {
    setShowOptions(!showOptions);
  };

  const handleMouseLeave = () => setShowOptions(false);

  // const ClientAdd = (result) => setClientAddIs(result);
  // const Redirect = () => {
  //   setRedirectTo1(true);
  // };

  const moveTo = (value) => {
    if (value === "redirect") {
      setRedirectTo1(false);
    } else if (value === "continue") {
      history.push("/settings/settingpracticeinfo");
      setRedirectTo1(false);
      handleCloseApp();
    }
  };

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => {
    setShow1(true);
    MyPlan();
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleOnline = () => {
    setIsOnline(true);
  };

  const handleOffline = () => {
    setIsOnline(false);
  };

  const handleInternetWarning = () => {
    setShowOnlineAlert(false);
  };

  const handleShowMesg = () => {
    if (alertData && alertData.total !== "0" && alertData.total !== 0) {
      axiosInstance
        .get("/vozo/appointment/notification/alert/update?uid=" + user_id)
        .then((response) => {})
        .catch((err) => {});
    }

    setNotifyAlert(false);
  };

  const handleCloseApp = () => {
    setShowApp(false);
    setTimeout(() => {
      if (location.pathname.includes("/patientlist")) {
        history.replace({
          location: location.pathname,
          search: "?refreshList=true",
        });
      }
    }, 100);
  };

  const handleShowApp = () => {
    if (storedNames.appt1_viewOnly) {
      alert("You only have view-only access.");
    } else {
      setShowApp(true);
    }
    const facId =
      localStorage.getItem("facility_id") &&
      Decrypt_Value(localStorage.getItem("facility_id"), "vozo");
    setFacId(facId);
    setOfficeId(authorized === "1" ? facId : String(main_facility));
  };

  const saveAlertMsg = (a, b) => {
    setShowApp(false);
    setModalAlerShow(b);
    setModalMsg(a);
  };

  const handleSearchChange = (data) => {
    setSearch(data);
    setnoresult("1");
    setFilteredPatients([]);
  };

  const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const handleFetchAppointments = () => {
    dispatch(changeFacilitySelect(true));
    setreload(!reload);
    setTimeout(
      () =>
        history.push("/schedule/calender", {
          Refresh: reload,
          apptStartDate: startDate,
        }),
      2000,
    );
  };

  const handleSpinneForNewApp = () => {
    console.log("Don't remove this function");
  };
  const generateRandomPassword = (length = 10) => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    return Array.from(
      { length },
      () => charset[Math.floor(Math.random() * charset.length)],
    ).join("");
  };
  const handleUpgradePlan = () => {
    axiosInstance
      .get("/vozo/loginemail?uid=" + uid)
      .then((res) => {
        let data = Decrypt_Value(res.data, "vozo");
        const randomPassword = generateRandomPassword();
        const EncryptrandomPassword = Encrypt_Value(randomPassword, "vozo");
        const url = new URL("https://signup.vozohealth.com/direct-login.php");
        url.searchParams.append("token", EncryptrandomPassword);
        url.searchParams.append("email", data["email"]);

        axiosInstance
          .put("/vozo/feedbackloginpass?uid=" + uid, EncryptrandomPassword)
          .then((res) => {
            let data = Decrypt_Value(res.data, "vozo");
          })
          .catch((err) => {
            console.error("there was an error while updating login status");
          });
        window.open(url.toString(), "_blank");
      })
      .catch((err) => {
        console.error("there was an error while updating login status");
      });
  };

  const MyPlan = () => {
    let dr = document.getElementById("remove_show"),
      dr_1 = document.getElementById("remove_show_1");

    dr.classList.remove("show");
    dr_1.classList.remove("show");
  };
  const refreshData = () => {
    const url = window.location.href;
    const arr = url.split("/");
    const item = arr.pop();
    if (item === "patientlist" || (arr[3] === "patient" && arr[4] === "nav")) {
      props.refreshPatient();
    } else {
      history.push("/patient/patientlist");
    }
  };

  const patientDashboard = (props) => {
    let lastIndex = props.lastIndexOf("-");

    let part1 = props.slice(0, lastIndex);
    let part2 = props.slice(lastIndex + 1);
    setSelectedPatientTitle(part1);
    setSearch(part1);
    const currentPath = window.location.pathname;
    if (currentPath.includes("patientdashboard")) {
      history.push("/patient/patientdashboard/" + part2);
      window.location.reload();
      // setTimeout(() => setSearch(""), 3000);

      const unlisten = history.listen((location, action) => {
        if (action === "PUSH") {
          setSearch("");
        }
      });
      return () => {
        unlisten();
      };
    } else {
      history.push("/patient/patientdashboard/" + part2);
      const unlisten = history.listen((location, action) => {
        if (action === "PUSH") {
          setSearch("");
        }
      });
      return () => {
        unlisten();
      };
    }
  };

  const gotoProfile = () => {
    setDropdownOpen(false);
    MyPlan();
    history.push("/settings/settingsmyprofile");
  };
  const successreload = (val) => {
    setAppointmentNotification(val);
  };

  const MsgRefresh = (val) => {
    setAppointmentSecureMessage(val);
  };

  useImperativeHandle(ref, () => ({
    dataFetch() {
      setRefresh((prevState) => !prevState);
    },
  }));

  const handlemsgOpen = () => {
    setShow2(true);
    dispatch(changeShowcontact(true));
    dispatch(GetMsgList());
    dispatch(gettotalUnreadCount({ uid: uid }));
    setid("0");
  };

  const handleclose = () => {
    setShow2(false);
    dispatch(changeShowcontact(false));
  };

  const handleClick = () => {
    if (accountType === "-1" || accountType === "1") {
      setShowUpgrade(true);
    } else {
      history.push("/popups/Tasks");
      dispatch(GetNav("iconclose"));
    }
  };

  const handleNew = useCallback(() => {
    // axios
    //   .get(WhatsNewUrl + "newPostAlert.php?type=post")
    //   .then((response) => {
    //     if (Number(response.data) === 0) {
    //       setNewPostAlert(false);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    let dr = document.getElementById("remove_show"),
      dr_1 = document.getElementById("remove_show_1");

    dr.classList.remove("show");
    dr_1.classList.remove("show");

    setNewOpen(true);
  });

  const handleOpenIntake = (data) => {
    setShow(false);
    setIntakeData(data);

    setShowIntakeForms(true);

    const article = {
      mail: data.email,
      userID: user_id,
      MailUrl: AccessMailUrl,
      pid: String(data.id),
    };
    let encrypted = Encrypt_Value(article, "vozo");
    axiosInstance
      .post("/vozo/patient/clientportalaccess/sendmail", encrypted)
      .catch((err) => {
        console.error(err);
      });
  };

  const handleCloseIntake = () => {
    setShowIntakeForms(false);
    refreshData();
  };

  const handleSendEmail = () => {
    const article = {
      mail: intakeData.email,
      userID: user_id,
      MailUrl: AccessMailUrl,
      pid: intakeData.id,
    };
    let encrypted = Encrypt_Value(article, "vozo");
    axiosInstance
      .post("/vozo/patient/clientportalaccess/sendmail", encrypted)
      .then((response) => {
        setModalMsg("ClientX Invite Sent successfully");
        setModalAlerShow(true);
        setTimeout(() => {
          setModalAlerShow(false);
        }, 4000);
      })
      .catch((error) => {});
  };
  // ------------------------------ Functions----end------------------------------------------------------ //

  // ------------------------------ useEffect----start---------------------------------------------------- //

  const getData = async () => {
    const checktokenreload =
      localStorage.getItem("checktokenreload") === "true";
    if (!checktokenreload) {
      await axiosInstance
        .get("vozo/validate/checktoken")
        .then((response) => {
          if (response.status !== 200) {
            window.location.reload();
          } else {
            localStorage.setItem("checktokenreload", true);
          }
        })
        .catch((err) => {
          window.location.reload();
        });
    }
    await axiosInstance
      .get("vozo/appointment/notification?uid=" + user_id)
      .then((response) => {
        let DecodeVal = Decrypt_Value(response.data, "vozo");

        setAppointmentNotification(DecodeVal);
      })
      .catch((err) => {});

    await axiosInstance
      .get("vozo/appointment/notification/alert?uid=" + user_id)
      .then((response) => {
        let DecodeVal = Decrypt_Value(response.data, "vozo");
        setAlertData(DecodeVal);
        if (
          DecodeVal.total !== "0" &&
          DecodeVal.total !== 0 &&
          !props.reqDrop
        ) {
          setNotifyAlert(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    await getNotify();

    if (props.reqDrop) {
      setNotifyAlert(false);
    }
  };

  useEffect(() => {
    if (!newOpen) postAlert();
    const handleCountryFetch = async () => {
      await axios
        .get(fileurl + "/interface/register/get_country_code_rpm.php")
        .then((res) => {
          setCountryCodes(res.data);
        })
        .catch((err) => {
          console.error(err.message);
          setCountryCodes([]);
        });
    };

    handleCountryFetch();
  }, []);

  useEffect(() => {
    const shouldReopen = localStorage.getItem("reopenCreateClient") === "true";
    if (shouldReopen) {
      localStorage.removeItem("reopenCreateClient");
      setShowApp(true);
    }
  }, []);

  const postAlert = useCallback(() => {
    axios
      .get(WhatsNewUrl + "newPostAlert.php?type=get")
      .then((response) => {
        if (Number(response.data) > 0) {
          setNewPostAlert(true);
        } else {
          setNewPostAlert(false);
        }
      })

      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getNotify = async () => {
    axiosInstance
      .get("/vozo/patient/notification/data?type=get&id=0&pov_id=" + user_id)
      .then((res) => {
        let data = Decrypt_Value(res.data, "vozo");
        setCountnotify(data);
        setMsgCount(data.total_count);
        if (data && data["alert"]) {
          setNotifyAlert1(true);
        } else {
          setNotifyAlert1(false);
        }
      })
      .catch(() => {
        setNotifyAlert1(false);
        setCountnotify([]);
      });
  };

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if (!isOnline) {
      setShowOnlineAlert(true);
    }
  }, [isOnline]);

  useEffect(() => {
    getData();
  }, [props.reqDrop, refresh, pathname, refreshTopNav]);

  useEffect(() => {
    axiosInstance
      .get("/vozo/task/seen/list?uid=" + user_id)
      .then((res) => {
        setSeenTask(res.data.count);
      })
      .catch((err) => {
        setSeenTask("0");
        console.log(err.message);
      });
  }, [props.tref]);

  useEffect(() => {
    dispatch(getSecureMessageList({ userId: user_id }));
    dispatch(gettotalUnreadCount({ uid: uid }));
  }, [refresh]);

  useEffect(() => {
    if (user_id !== undefined && user_id !== null && user_id !== "") {
      axiosInstance
        .get("/sprovider?uid=" + user_id)
        .then((response) => {
          const Decrypt_Value_1 = Decrypt_Value(response.data, "vozo");
          setpatimg(Decrypt_Value_1.img_url);
          setusername(Decrypt_Value_1.fname + " " + Decrypt_Value_1.lname);
          setuseremail(Decrypt_Value_1.email);

          // if (
          //   Decrypt_Value_1?.account_type === 0 &&
          //   !Decrypt_Value_1?.trial_period
          // ) {
          //   var trial_enc = Encrypt_Value(Decrypt_Value_1.trial_period, "vozo");

          //   localStorage.setItem("trial_period", trial_enc);
          //   history.push("/settings/SubscriptionExpired");
          // }
          if ([1, 2].includes(Decrypt_Value_1?.account_update)) {
            logout(uid);
          }
        })
        .catch((err) => console.log("Error fetching user profile:", err));
    }
  }, [refresh, pathname, user_id]);

  useEffect(() => {
    let isCancelled = false;
    const handlechange = async () => {
      await timeout(1000);
      if (!isCancelled) {
        if (search !== "") {
          let Data_ =
            "limit=10&fname=" +
            search +
            "&authorized=" +
            authorized +
            "&main_pro=" +
            main_pro +
            "&userID=" +
            user_id +
            "&pat_share=" +
            storedNames.pat_share +
            "&owner_id=" +
            owner_id;

          let Data_1 = Encrypt_Value(Data_, "vozo");

          axiosInstance
            .get("/vozo/patienttopsearch?search=" + Data_1)
            .then((response) => {
              let DecodeVal = Decrypt_Value(response.data, "vozo");

              setFilteredPatients(DecodeVal);
              setnoresult(DecodeVal);
            })

            .catch((err) => {
              setFilteredPatients([]);
              setnoresult("");
            });
        }
      }
    };

    handlechange();
    return () => {
      isCancelled = true;
    };
  }, [search]);

  useEffect(() => {
    setProChat(count);
  }, [count]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (step === "6.5" && fromComponent) {
      setShowStepFiveIntro(true);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "6.6") {
      setShowStepSixIntro(true);
      setShowApp(true);
      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
    if (fromComponent === false) {
      setShowStepFiveIntro(false);
    }
  }, [location?.search, trigger]);

  // ------------------------------ useEffect----end---------------------------------------------------
  return (
    <>
      <Navbar
        bg="light"
        variant="light"
        className={
          Showcontact || showAdd1 || showAdd2
            ? "top-navbar top-nav-fixed1"
            : "top-navbar top-nav-fixed"
        }
      >
        <Navbar.Brand as={Link} to="/schedule/calender" className="nav-logo">
          <img
            src={logo}
            className="d-inline-block align-top vozo-logo"
            alt="vozo-logo"
            height="48px"
          />
        </Navbar.Brand>

        <div className="top_nav_display">
          <Dropdown>
            <Popup
              offset={[50, 20]}
              content={
                <GetStartedPopup
                  title="Schedule your first appointment"
                  bullets={[
                    "Click Create > Create Appointment to schedule a new appointment",
                    "Or Click any time slots from the calendar to schedule an apppointment",
                  ]}
                  currentStep={5}
                  totalSteps={6}
                  onNext={handleIntroNext}
                  onBack={handleIntroBack}
                  onClose={() => setShowStepFiveIntro(false)}
                  width="320px"
                />
              }
              open={showStepFiveIntro}
              className="astopnav m-t-10"
              trigger={<div></div>}
              position="left center"
            />
            <Dropdown.Toggle
              variant="primary"
              id="dropdown-basic cal-btn-crate"
              className="save_active top-nav-dropdown  tk-cd-indctr"
              disabled={expired_days < 0}
              title="Create"
            >
              <Add />
              Create
            </Dropdown.Toggle>
            {storedNames && (
              <Dropdown.Menu className="drop-down-list">
                {storedNames.demo ? (
                  <Dropdown.Item
                    onClick={(e) => {
                      if (storedNames.demo1_viewOnly || storedNames.demo_v) {
                        alert("You only have view-only access.");
                      } else {
                        handleShow();
                      }
                    }}
                    className="top-nav-dp-list"
                  >
                    <Add />
                    Create Client
                  </Dropdown.Item>
                ) : null}
                {storedNames.appt ? (
                  <Dropdown.Item
                    onClick={handleShowApp}
                    className="top-nav-dp-list"
                    id="appt_crt-ico-nav"
                  >
                    <CalendarTodayOutlined />
                    Create Appointment
                  </Dropdown.Item>
                ) : null}
              </Dropdown.Menu>
            )}
          </Dropdown>
          {owner_id === null && (
            <Dropdown>
              <Dropdown.Toggle
                variant="primary"
                id="dropdown-basic"
                className="top-nav-upgrade-button"
                onClick={handleUpgradePlan}
                disabled={expired_days < 0}
                title="Upgrade Plan"
              >
                <UpgradeArrowIcon className="upgrade-arrow-icon" />
                <span className="upgrade-text">Upgrade Plan</span>
              </Dropdown.Toggle>
            </Dropdown>
          )}
          {/* <Search
          placeholder="Patient Search"
          onResultSelect={(e, data) => patientDashboard(data)}
          onSearchChange={handleSearchChange}
          noResultsMessage={
            fornoresults != "" ? "loading..." : "No Results Found"
          }
          className="top-nav-pat-search"
          results={filteredPatients}
          value={search}
        /> */}
          <form autoComplete="off">
            <div
              className="for_autoComplete_bi_Patient pat-search-autocomplete top-nv-pat-srch"
              title={
                selectedPatientTitle
                  ? selectedPatientTitle
                  : "Patient Search by Name,SSN,Email,DOB"
              }
            >
              <span className="top-search-icon">
                <AiOutlineSearch />
              </span>
              <AutoComplete
                virtual={false}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                autoComplete="off"
                onClick={mouseClick}
                // onMouseLeave={handleMouseLeave}
                placeholder="Patient Search by Name,SSN,Email,DOB"
                onSelect={patientDashboard}
                onSearch={handleSearchChange}
                dropdownClassName={
                  search !== ""
                    ? "top_pat_search"
                    : "for_no_loading top_pat_search"
                }
                notFoundContent={
                  showOptions
                    ? fornoresults.length !== 0
                      ? "loading..."
                      : "No Results Found"
                    : ""
                }
                className="top-nav-pat-search"
                id="top-nav-pat-search"
                options={
                  showOptions &&
                  filteredPatients.map((x) => {
                    const titleLength = x.title.length;
                    return {
                      label: (
                        <div>
                          <div className="toplabel">
                            {titleLength < 15 ? (
                              <>
                                {x.title} -{" "}
                                {x.DOB ? moment(x.DOB).format(dtFormat) : ""}
                              </>
                            ) : (
                              <>
                                <div>{x.title} -</div>
                                <div>
                                  {x.DOB ? moment(x.DOB).format(dtFormat) : ""}
                                </div>
                              </>
                            )}
                          </div>
                          <div>
                            {(() => {
                              const { countryCode, phoneNumber } =
                                parsePhoneForDisplay(
                                  x.phone_cell.replace(/[^0-9+_ ]/g, ""),
                                  countryCodes,
                                );
                              return `${countryCode} ${phoneNumber}`.trim();
                            })()}
                          </div>
                        </div>
                      ),
                      value: x.title + "-" + x.value,
                    };
                  })
                }
                value={search}
                disabled={expired_days < 0}
              />
            </div>
          </form>
          {storedNames?.mesg && (
            <div className="top-msg-icon1" title="Message">
              {(proChat != "noData" || NewMsgs !== 0) && <Prompt />}
              <Button1
                className="top-msg-btn"
                borderRadius="6px"
                padding="0px"
                backgroundColor="#ffffff"
                color="rgba(46, 46, 46, 1)"
                onClick={handlemsgOpen}
                disabled={expired_days < 0}
              >
                <SquareMessageIcon className="big-top-icon" />
              </Button1>
            </div>
          )}
          <>
            {storedNames && storedNames.show_notification && (
              <Dropdown
                show={props.reqDrop}
                onToggle={props.DropReq}
                className="top-nav-rem-pad"
                title="Notification"
              >
                <Dropdown.Toggle
                  variant="link"
                  id="dropdown-basic"
                  disabled={expired_days < 0}
                >
                  <a
                    href="#"
                    onClick={handleShowMesg}
                    className="top-msg-icon1"
                  >
                    <CustomBellIcon
                      id="appt-inp_bell"
                      className={
                        NotifyAlert1 || NotifyAlert
                          ? "custom-bell-icon bell-icon1"
                          : "custom-bell-icon bell-icon"
                      }
                    />
                  </a>
                </Dropdown.Toggle>
                <Dropdown.Menu align="center">
                  <div className="dropdown-menu show app-notification for-tab-style ">
                    <Notifications
                      secMsgData={AppointmentSecureMessage}
                      appData={AppointmentNotification}
                      profileimage={
                        patimg === null
                          ? ""
                          : generateFileURL(fileTypes.profileimages, patimg)
                      }
                      successreload={successreload}
                      MsgRefresh={MsgRefresh}
                      MsgCount={MsgCount}
                      notifyCount={countnotify}
                      refid={props.refid}
                      providerName={username}
                      calRefHandle={props.calRefHandle}
                      show={props.reqDrop}
                      changeDrop={props.DropReq}
                      getNotify={getNotify}
                      genNotification={false}
                    />
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </>
          <div
            className="top-msg-icon1"
            title="Account Setup"
            onClick={() => history.push("/settings/accountsetup")}
          >
            <MdManageAccounts className="big-top-icon account-setting-icon" />
          </div>
          <div className="top-msg-icon1" title="Task Managment">
            {seenTask !== 0 && <Prompt />}
            <div onClick={expired_days < 0 ? "" : handleClick}>
              <SmallPlusIcon
                className="small-plus-icon"
                style={{ color: "#212121" }}
              />
            </div>
          </div>
          <Dropdown
            id="remove_show"
            show={dropdownOpen}
            onToggle={(isOpen) => setDropdownOpen(isOpen)}
            onClick={() => {
              setDropdownOpen(!dropdownOpen);
              postAlert();
            }}
          >
            <Dropdown.Toggle
              variant="link"
              id="dropdown-basic"
              disabled={expired_days < 0}
              title="My Profile"
            >
              {patimg === null || patimg === "" ? (
                <Avatar
                  size={28}
                  className="topNavBarAvat topnav_popavatar top-nav-bg-col"
                >
                  <span className="topNavBarAvatar top-nav-pro-cap">
                    {username.charAt(0).toUpperCase()}
                  </span>
                </Avatar>
              ) : (
                <Avatar
                  size={28}
                  icon={
                    <img
                      src={generateFileURL(fileTypes.profileimages, patimg)}
                      alt="pic-failed"
                      loading="lazy"
                      width="193px"
                      height="130px"
                    />
                  }
                />
              )}
            </Dropdown.Toggle>
            <Dropdown.Menu id="remove_show_1" className="topnav_card_top">
              <div className="card_container topnavcard">
                <div className="ArrowUp"></div>
                <div className="card_top topnav_popup_passdisplay">
                  <div>
                    {patimg === null ? (
                      <Avatar
                        size={40}
                        className="topNavBarAvat topnav_popavatar top-nav-bg-col"
                      >
                        <span className="topNavBarAvatar top-nav-drop-item-icon">
                          {username.charAt(0).toUpperCase()}
                        </span>
                      </Avatar>
                    ) : (
                      <Avatar
                        size={25}
                        icon={
                          <img
                            src={generateFileURL(
                              fileTypes.profileimages,
                              patimg,
                            )}
                            alt="pic-failed"
                            loading="lazy"
                            width="193px"
                            height="130px"
                          />
                        }
                      />
                    )}
                    {/* <Avatar in need code
                    size={32}
                    style={{ background: "#A8AEBE", marginTop: "9px" }}
                    className="topNavBarAvat1"
                  >
                    <span className="topNavBarAvatar">
                      {username.charAt(0).toUpperCase()}
                    </span>
                  </Avatar> */}
                  </div>
                  <div className="avatarcard_info navpopname">
                    <div className="app_pro_text_wrap aname" title={username}>
                      <span className=" aname" float="left">
                        {username}
                      </span>
                    </div>

                    <div className="app_pro_text_wrap amail" title={useremail}>
                      <span className=" amail" float="left">
                        {useremail}
                      </span>
                    </div>
                  </div>
                  <div
                    className="avatarcard_edit topnav_avatarcard_"
                    onClick={gotoProfile}
                  >
                    Edit
                  </div>
                </div>

                <hr className="hr.horizline"></hr>
                {/* My Plan */}
                {(owner_id === null || owner_id === " ") && (
                  <NavLink
                    className="plan topnav_popup_passdisplay plan_pass plan_myplan Myplan_alt top-nv-link-color"
                    onClick={MyPlan}
                    to="/settings/myplan"
                  >
                    <AcUnitOutlinedIcon />
                    <div className="ico_word">My Plan</div>
                  </NavLink>
                )}

                {/* Change Password */}
                <div className="pass bar topnav_popup_pass plan_pass pass_alt">
                  <div className="lock topnav_popup_passdisplay">
                    <BiLockAlt className="topnav_popup_pass_icon" />
                    <div className="ico_word" onClick={handleShow1}>
                      Change Password
                    </div>
                  </div>
                </div>

                {/* Divider 1 */}
                <div className="menu-divider"></div>

                {/* What's New */}
                <div className="pass bar topnav_popup_pass plan_pass pass_alt">
                  <div className="lock topnav_popup_passdisplay">
                    <Image src={whats_new_loudspeaker} height={20} width={20} />
                    <div className="ico_word" onClick={handleNew}>
                      What's New
                    </div>
                  </div>
                </div>

                {/* Help Center */}
                <div className="pass bar topnav_popup_pass plan_pass pass_alt">
                  <div className="lock topnav_popup_passdisplay">
                    <BiHelpCircle className="topnav_popup_pass_icon" />
                    <div
                      className="ico_word"
                      onClick={() =>
                        window.open(
                          "https://help.vozohealth.com/product-guide/creating-a-trial-account/",
                          "_blank",
                        )
                      }
                    >
                      Help Center
                    </div>
                  </div>
                </div>

                {/* Contact Support */}
                <div className="pass bar topnav_popup_pass plan_pass pass_alt">
                  <div className="lock topnav_popup_passdisplay">
                    <BsHeadset className="topnav_popup_pass_icon" />
                    <div
                      className="ico_word"
                      onClick={() =>
                        window.open(
                          "https://www.vozohealth.com/talk-to-us",
                          "_blank",
                        )
                      }
                    >
                      Contact Support
                    </div>
                  </div>
                </div>

                {/* Divider 2 */}
                <div className="menu-divider"></div>

                {/* Logout */}
                <div className="log bar" onClick={() => logout(uid)}>
                  Log out
                </div>
              </div>
            </Dropdown.Menu>
          </Dropdown>
          <p
            className={
              newPostAlert ? "new_source_red_dot new_source_profile" : ""
            }
          ></p>
        </div>
        <Modal
          show={show1}
          onHide={handleClose1}
          className="change_password_popup"
          dialogClassName="modal-dialog-centered-custom"
        >
          <PasswordExpired close={handleClose1} />
        </Modal>

        <Modal
          className="client-popup topcreate_popup_centre wid_562"
          centered
          show={show}
          onHide={handleClose}
        >
          <CreateClient
            clientShow={setShow}
            dataFetch={refreshData}
            // ClientAdd={ClientAdd}
            ClientAdd={setClientAddPopup}
            ClientFailed1={setClientFail1}
            openIntake={handleOpenIntake}
          />
        </Modal>

        <Modal
          className="app-popup  new_appt popup_centre  change-top-new-appt custom-modal-width"
          centered
          show={showApp}
          onHide={handleCloseApp}
        >
          {/* <Modal.Header className="c-app" closeButton></Modal.Header> */}

          <NewAppointment
            onBookAppointment={() => {}}
            getStartApptDate={getStartApptDate}
            // start={false}
            type="new appointment"
            getAppointmentData={() => {}}
            dataObj={[]}
            fromDashboard={true}
            setappshow={setShowApp}
            providerSelect={[uid]}
            showStepSixIntro={showStepSixIntro}
            setShowStepSixIntro={setShowStepSixIntro}
            // start={[]}
            closepopup={handleCloseApp}
            // start={false}
            provider={authorized === "1" ? uid : main_pro}
            facility={authorized === "1" ? ufc : String(main_facility)}
            provarray={provarray}
            facarray={facarray}
            pat_share={storedNames && storedNames.pat_share}
            savealertmsg={saveAlertMsg}
            popuphide={() => setModalAlerShow(false)}
            FetchAppointments={handleFetchAppointments}
            setspinnerfornewapp={handleSpinneForNewApp}
            officeId={officeId}
            appFromDate={apptFromDate}
            apptoDate={apptToDate}
            examroom={false}
            // redirect={Redirect}
            where="top"
            view={"day"}
            startTime1={""}
            ApptTab={"1"}
            defaultTele={false}
            handlesetDefaultTele={() => {}}
            handlesetApptTab={() => {}}
          />
        </Modal>
        <Modal
          className="user-guide-popup-box"
          show={redirectTo1}
          onHide={() => setRedirectTo1(false)}
        >
          <Modal.Header style={{ borderBottom: "none" }} closeButton>
            <div className="pass-alert-rect">
              <img
                src={rect}
                width="60px"
                height="60px"
                style={{ borderRadius: 8 }}
                alt="ColoredEdge"
              />
            </div>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="expire-modal-heading"
              style={{ fontSize: "19px", marginTop: "0px", marginLeft: "0px" }}
            >
              One Final Step
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p
                className="expire-modal-para"
                style={{
                  color: "#4b4b4b",
                  marginLeft: "0px",
                  fontSize: "16px",
                }}
              >
                Let's Add your Billing Information
              </p>
              <p
                className="expire-modal-para"
                style={{
                  color: "#4b4b4b",
                  marginLeft: "0px",
                  fontSize: "16px",
                }}
              >
                Click continue to add your billing information
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ padding: "20px" }}>
            <Button
              variant="light"
              onClick={() => setRedirectTo1(false)}
              style={{ margin: "0px 20px 0px 0px", padding: "4.5px 8px" }}
            >
              Cancel
            </Button>
            <Button
              style={{ margin: "0px ", padding: "4.5px 8px" }}
              onClick={() => moveTo("continue")}
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          className="alert-popup-message"
          show={modalAlerShow}
          onHide={() => setModalAlerShow(false)}
        >
          <div className="alert msg alert-success" role="alert">
            <BsCheckCircle className="icons-bs" />
            {modalMsg}
          </div>
        </Modal>
        {/* <Modal
          className="alert-popup-message"
          show={typeof clientAddIs === "string"}
        >
          <div className="alert msg alert-success" role="alert">
            <BsCheckCircle className="icons-bs" />
            <span style={{ marginLeft: "8px" }}>{clientAddIs}</span>
          </div>
        </Modal> */}
      </Navbar>
      <Modal
        className="alert-popup-message"
        show={showOnlineAlert}
        onHide={handleInternetWarning}
      >
        <div
          className="alert msg alert-danger"
          role="alert"
          onClick={handleInternetWarning}
        >
          <MdOutlineSignalWifiConnectedNoInternet4 className="icons-bs" /> No
          internet. Check your internet connection.
        </div>
      </Modal>

      {show2 && (
        <Messenger
          show2={show2}
          close={handleclose}
          proChatCount={proChat != "noData" ? proChat : 0}
          id={id}
          providerName={username}
          profileimage={
            patimg === null
              ? ""
              : generateFileURL(fileTypes.profileimages, patimg)
          }
        />
      )}

      {showUpgrade && (
        <UpgradeRequired
          title="Task Management"
          description="View and assign task to other providers based on urgency and to prioritize the task assigned to them"
          boxContent={
            <span>
              Available in
              <span className="upgradFont"> Premium</span> plan
            </span>
          }
          handlecloseUpgrade={() => setShowUpgrade(false)}
        />
      )}

      {newOpen && (
        <NewSource
          setNewPostAlert={setNewPostAlert}
          newPostAlert={newPostAlert}
          newOpen={newOpen}
          setNewOpen={setNewOpen}
          finalURL={WhatsNewUrl}
        />
      )}

      <Modal className="alert-popup-message" show={clientFail1}>
        <div className="alert msg alert-danger" role="alert">
          <IoCloseSharp className="icons-bs" /> This email is already used for
          an existing patient. Please use a different email.
        </div>
      </Modal>
      <Modal
        className="alert-popup-message"
        show={clientAddPopup.show}
        animation={false}
        backdrop={false}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          <span style={{ marginLeft: "8px" }}>{clientAddPopup.message}</span>
        </div>
      </Modal>

      {showIntakeForms && (
        <IntakeForms
          toShow={showIntakeForms}
          toHide={handleCloseIntake}
          patientName={intakeData.name}
          patientMail={intakeData.email}
          patientId={intakeData.id}
          from="create_client"
          sendemailClick={handleSendEmail}
        />
      )}
    </>
  );
});
export default memo(TopNavbar);
